import { render, staticRenderFns } from "./OInfoPurchaseComp.vue?vue&type=template&id=0608b568&"
import script from "./OInfoPurchaseComp.vue?vue&type=script&lang=js&"
export * from "./OInfoPurchaseComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports